/**
 * Schema-v2 shape of welby_configuration/patient_status.
 * Written by scripts/welby-firestore/maintenanceScripts/sprint-07-17-26/patient-status-v2.
 */
export interface PatientStatusCatalogItem {
  key: string;
  label: string;
  active: boolean;
  deceased: boolean;
  deprecated: boolean;
  legacyLabels?: string[];
  sortOrder: number;
}

export const PENDING_ACTIVATION_LABEL = 'Inactive - Pending Activation';

export interface PatientStatusConfig {
  /** Selectable labels only (deprecated statuses are excluded here but kept in `catalog`). */
  items: string[];
  /** Full metadata source: current + deprecated statuses, with legacy-label mappings. */
  catalog: PatientStatusCatalogItem[];
  schemaVersion?: number;
}
